import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { NewsArticleModel } from '../../../../models/data-sections/news/articleModel';

interface NewsModalProps {
  selected_article: NewsArticleModel;
  searchExecutionId: string;
  onClose: () => void; // optional if used elsewhere
}

const NewsModal: React.FC<NewsModalProps> = ({ selected_article }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="h6">{selected_article.title}</Typography>

      <Typography variant="subtitle2" color="textSecondary">
        {selected_article.source} &nbsp;|&nbsp; {new Date(selected_article.time_published).toLocaleString()}
      </Typography>

      {selected_article.authors.length > 0 && (
        <Box display="flex" gap={1} flexWrap="wrap">
          {selected_article.authors.map((author, idx) => (
            <Chip key={idx} label={author} size="small" />
          ))}
        </Box>
      )}

      <Typography variant="body1" mt={2}>
        {selected_article.summary}
      </Typography>

      <Typography mt={2}>
        <strong>Sentiment:</strong> {selected_article.overall_sentiment_label} ({selected_article.overall_sentiment_score.toFixed(2)})
      </Typography>

      <Typography mt={2}>
        <strong>URL:</strong>{' '}
        <a href={selected_article.url} target="_blank" rel="noopener noreferrer">
          {selected_article.url}
        </a>
      </Typography>
    </Box>
  );
};

export default NewsModal;
